
            import path from "/home/jianxin_yang/Workspaces/Github/markdown-it-smiles/node_modules/.pnpm/canvas@3.1.0/node_modules/canvas/build/Release/canvas.node"
            try { module.exports = require(path) }
            catch {}
          